import React, { useCallback, useMemo, useRef, useState } from "react";
import { Text, ActionBar, Popover } from "@bookingcom/bui-react";
import { PersonHalfIcon, AccountUsersIcon } from "@bookingcom/bui-assets-react/streamline";
import { ShellButton } from "../Shell/index.js";
import { t } from "@bookingcom/lingojs-core";
import OccupancyCabinClass from "./OccupancyCabinClass.js";
import useOccupancyCabinClass from "./useOccupancyCabinClass.js";
import styles from "./OccupancyCabinClassDropDown.module.css";
const OccupancyCabinClassDropDown = (props) => {
    const { cabinClassVariant } = props;
    const { cabinClass, occupancy, setCabinClass, setOccupancy, cabinClassName, errorMessage, i18n, trackV2, isOccupancySelected, travellers } = useOccupancyCabinClass();
    const buttonref = useRef(null);
    const [active, setActive] = useState(false);
    const [state, setState] = useState(occupancy);
    const text = useMemo(() => {
        return i18n.trans(t("flights_search_traveller_criteria", {
            variables: {
                passenger_count: i18n.trans(t("flights_search_passenger_count_mix", {
                    num_exception: travellers,
                    variables: { num_travellers: travellers }
                })),
                cabin_class: cabinClassName
            }
        }));
    }, [i18n, travellers, cabinClassName]);
    const icon = useMemo(() => {
        return travellers === 1 ? PersonHalfIcon : AccountUsersIcon;
    }, [travellers]);
    const trackEvent = useCallback(() => {
        if (!isOccupancySelected)
            return;
        if (occupancy.adults !== state.adults ||
            occupancy.children.length !== state.children.length ||
            occupancy.children.some((a, i) => state.children[i] !== a)) {
            setState(occupancy);
            trackV2("select_travelers", {
                number_adults: occupancy.adults,
                number_children: occupancy.children.length,
                children_ages: occupancy.children
            });
        }
    }, [occupancy, state, isOccupancySelected, trackV2]);
    const handleOnClose = useCallback(() => {
        setActive(false);
        setCabinClass(cabinClass);
        setOccupancy(occupancy);
        trackEvent();
    }, [setCabinClass, setOccupancy, occupancy, cabinClass, trackEvent]);
    const handleOnClick = useCallback(() => {
        setActive(false);
        trackV2("click_passenger_done");
    }, [trackV2]);
    const handleOnOpen = useCallback(() => {
        setActive(true);
    }, []);
    const errorId = "occupancy_cabin_class_modal_error";
    return (React.createElement(React.Fragment, null,
        React.createElement(ShellButton, { icon: icon, errorMessage: errorMessage, errorId: errorId, errorVariant: "tooltip", title: i18n.trans(t("a11y_flights_searchbox_travellers_class_button")), "aria-label": i18n.trans(t("a11y_flights_searchbox_travellers_class_button")), "aria-describedby": errorId, "aria-invalid": "true", "aria-live": "polite", ref: buttonref, "data-ui-name": "button_occupancy", "data-ui-error": Boolean(errorMessage), size: "medium", onClick: (e) => {
                e.stopPropagation();
                setActive(true);
                trackV2("click_passenger");
            } },
            React.createElement(Text, { tagName: "span", variant: "body_2" }, text)),
        React.createElement(Popover, { fill: true, hideClose: true, active: active, onClose: handleOnClose, onOpen: handleOnOpen, position: "bottom-end", triggerType: "click", triggerRef: buttonref },
            React.createElement(Popover.Content, null,
                React.createElement("div", { className: styles.content },
                    React.createElement("div", { className: styles.contentScrollArea },
                        React.createElement("div", { style: { paddingBottom: "var(--bui_spacing_4x)" } },
                            React.createElement(Text, { variant: "strong_1" }, i18n.trans(t("flights_search_popover_travellers_title"))),
                            React.createElement(Text, { color: "neutral_alt", variant: "body_2" }, i18n.trans(t("flights_search_popover_travellers_subtitle")))),
                        React.createElement(OccupancyCabinClass, { occupancyHideTitle: true, cabinClassVariant: cabinClassVariant })),
                    React.createElement("div", { className: styles.contentFooter },
                        React.createElement(ActionBar, { button: {
                                wide: true,
                                text: i18n.trans(t("flights_action_done")),
                                onClick: handleOnClick,
                                attributes: {
                                    "data-ui-name": "button_occupancy_action_bar_done"
                                }
                            } }, text)))))));
};
export default OccupancyCabinClassDropDown;
